import {DataContentWrapper} from '@hconnect/common/containers'
import {Iso8601} from '@hconnect/common/types'
import {CardBox} from '@hconnect/uikit/src/lib2'
import {CalendarTodayOutlined} from '@mui/icons-material'
import {Box, Chip, SxProps, Theme, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {RcfaSummaryWithProgressChart} from '../components'
import {DOWNTIME_ANALYTICS_WIDGET_NAMESPACE} from '../consts'
import {useRcfaAvailability} from '../hooks'

type Props = {
  plantId: string
  from: Iso8601
  to: Iso8601
  timeRangeLabel: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
}

export const RcfaSummaryChartContainer = ({
  plantId,
  from,
  to,
  timeRangeLabel,
  cardBoxSx,
  placeholderWrapperSx
}: Props) => {
  const {t} = useTranslation(DOWNTIME_ANALYTICS_WIDGET_NAMESPACE)
  const {data, isLoading, isError, isRefetching, refetch} = useRcfaAvailability({plantId, from, to})

  return (
    <CardBox
      sx={{display: 'flex', flexDirection: 'column', ...cardBoxSx, px: 3}}
      data-test-id="rcfa-summary-card"
    >
      <Box display="flex" flexDirection="row">
        <Box flex={1}>
          <Typography variant="h3" mb={2}>
            {t('rcfaSummary.cardTitle')}
          </Typography>
        </Box>
        <Chip icon={<CalendarTodayOutlined />} label={timeRangeLabel} size="small" sx={{ml: 1}} />
      </Box>
      <DataContentWrapper
        placeholderWrapperSx={placeholderWrapperSx}
        showLoader={isLoading}
        isError={isError}
        isRefetching={isRefetching}
        data={data}
        retryFunction={() => void refetch()}
        progressSx={{color: 'primary.main'}}
      >
        {data && <RcfaSummaryWithProgressChart {...data} timeRangeLabel={timeRangeLabel} />}
      </DataContentWrapper>
    </CardBox>
  )
}
